<template>
  <div class="error-container">
    <div class="error-content">
      <el-row :gutter="20">
        <el-col>
          <div class="pic-error">
            <h3>トライアル版では利用できません</h3>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'PageEmpty',
    data() {
      return {}
    },
    mounted() {},
    beforeDestroy() {},
    methods: {},
  }
</script>

<style lang="scss" scoped></style>
